module.exports = __webpack_public_path__ + "static/media/bet-green-2.ebb037fb.png";